"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/*
COPYRIGHTED BY: Aron Barbosa de Oliveira
Under GNU/GPL License
https://github.com/aronboliveira
*/
var react_1 = require("react");
var client_1 = require("react-dom/client");
var App_1 = require("./App");
require("./assets/styles/flatsomeStyles.scss");
require("./assets/styles/style.scss");
require("./assets/styles/viteAdjustements.scss");
require("./lib/head/js/wp/wp-emoji-release");
require("./lib/head/js/wp/wp-polyfill");
require("./lib/head/js/flatsome/flatsome");
require("./lib/head/js/flatsome/flatsome-live-search");
(0, client_1.createRoot)(document.getElementById("root")).render((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(App_1.default, {}) }));
